import squel from 'squel';
import SQLDatabase from './db/sql.service';
import { recomputeTreeSyncErrorsForRecord } from './db/tree-sync-error.service';
import {
  clearSyncErrorAttribute,
  parseSyncError,
  serialiseSyncError
} from './sync-error.service';

const writeSyncError = async (recordId: number, syncError: string | null): Promise<void> => {
  const statement = squel.update()
    .table('records')
    .where('id = ?', recordId)
    .set('syncError', syncError);
  const { text, values } = statement.toParam();
  await SQLDatabase.instance.executeSet([{
    statement: text,
    values
  }]);
};

export const setRecordSyncError = async (recordId: number, error: unknown): Promise<void> => {
  await writeSyncError(recordId, serialiseSyncError(error));
};

export const clearRecordSyncError = async (recordId: number): Promise<void> => {
  await writeSyncError(recordId, null);
};

export const patchClearSyncErrorAttribute = async (recordId: number, path: string): Promise<void> => {
  const [row] = await SQLDatabase.instance.query<{ syncError: string | null }>(
    'SELECT syncError FROM records WHERE id = ?',
    [recordId]
  );

  if (!row?.syncError) {
    return;
  }

  const cleared = clearSyncErrorAttribute(parseSyncError(row.syncError), path);
  const serialised = cleared ? JSON.stringify(cleared) : null;
  await writeSyncError(recordId, serialised);
  await recomputeTreeSyncErrorsForRecord(recordId);
};
